<script>
    export let id;
    export let text;
    export let value;
    export let maxValue;
</script>

<label for="{id}">{text}</label>
<input id="{id}" name="{id}" type="number" bind:value={value} min=1 max={maxValue}>

<style>
    input{
        width: 50px;
        text-align: center;
    }
</style>